import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

import { IntegrationListComponent } from './integrationlist/integration-list.component';
import { IntegrationComponent } from './integration/integration.component';

import { IntegrationModel } from 'app/shared/models/integration.model';

@Component({
    selector: 'app-integrations',
    templateUrl: './integrations.component.html'
})
/**
 * Component for Integrations view.
 */
export class IntegrationsComponent {
    dialogRef: MdDialogRef<any>;
    selectedData: Object;
    showCitcoButtons = environment.showCitcoButtons; // @todo tenant specific.

    @ViewChild('integrations') integrationsList: IntegrationListComponent;

    constructor(
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService
    ) { }

    openAddIntegrationDialog() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(IntegrationComponent, config);
        this.dialogRef.componentInstance.action = 'Add';
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updateIntegrationsListAfterAdd(result);
            }
        });
    }

    updateIntegrationsListAfterAdd(formResponse: IntegrationModel) {
        this.integrationsList.updateIntegrationsList();
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/integrations/integrations.component.ts